/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .contact[_ngcontent-%COMP%]{display:flex}[_nghost-%COMP%]   .contact[_ngcontent-%COMP%]   .avtar[_ngcontent-%COMP%]{border-radius:50%;width:48px;height:48px}[_nghost-%COMP%]   .contact[_ngcontent-%COMP%]   .core[_ngcontent-%COMP%]{margin-left:12px;display:flex;flex-direction:column;justify-content:center}"];
export { styles as styles };
